import React, { useState, useEffect } from 'react';

const CountdownWidget = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const timer = setInterval(() => {
      const difference = +new Date(targetDate) - +new Date();
      let totalSeconds = Math.floor(difference / 1000);

      if (totalSeconds > 0) {
        setTimeLeft({
          h: Math.floor((totalSeconds / 3600) % 24),
          m: Math.floor((totalSeconds / 60) % 60),
          s: Math.floor(totalSeconds % 60),
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="instrument-widget countdown-widget">
      <div className="timer-display">
        <div className="time-unit">
          <span>{timeLeft.h || '00'}</span>
          <label>H</label>
        </div>
        <span className="colon">:</span>
        <div className="time-unit">
          <span>{timeLeft.m || '00'}</span>
          <label>M</label>
        </div>
        <span className="colon">:</span>
        <div className="time-unit">
          <span>{timeLeft.s || '00'}</span>
          <label>S</label>
        </div>
      </div>
      <div className="counter-label">START</div>
      <div className="status-tag pulse">COUNTDOWN</div>
    </div>
  );
};

export default CountdownWidget;
